<template>
  <div class="service-open">
    <!-- 服务开通标题 -->
    <div class="body-title">
      <el-divider>
        <div class="flex">
          <img
            class="title-icon"
            src="@/assets/images/supplier/guarantee-pre-save/title-icon.png"
            alt=""
          />
          <span class="title-main">灵活宝</span>
          <span class="title-second">保证金预存</span>
        </div>
      </el-divider>
    </div>
    <!-- 服务宣传 -->
    <div class="publicity">
      <img
        src="@/assets/images/supplier/guarantee-pre-save/publicity-1.png"
        alt=""
      />
      <img
        src="@/assets/images/supplier/guarantee-pre-save/publicity-2.png"
        alt=""
      />
      <img
        src="@/assets/images/supplier/guarantee-pre-save/publicity-3.png"
        alt=""
      />
      <img
        src="@/assets/images/supplier/guarantee-pre-save/publicity-4.png"
        alt=""
      />
    </div>
    <!-- 开通操作 -->
    <div class="open-action">
      <el-button class="open-button" type="primary" @click="openPreSaveAccount">
        立即开通
      </el-button>
      <!--<el-checkbox v-model="agreementChecked" class="m-t-21">-->
      <!--  同意-->
      <!--  <el-button type="text" @click="visible = true">-->
      <!--    灵活宝用户协议-->
      <!--  </el-button>-->
      <!--</el-checkbox>-->
    </div>
    <el-divider />
    <!-- 服务说明 -->
    <div class="service-desc">
      <div class="desc-title">服务说明：</div>
      <ol>
        <li v-for="item in serviceDescList" :key="item">{{ item }}</li>
      </ol>
    </div>

    <el-dialog
      class="dialog"
      :visible.sync="visible"
      title="灵活宝用户协议"
      :close-on-click-modal="false"
      append-to-body
    >
      <div>协议内容</div>
    </el-dialog>
  </div>
</template>

<script>
import useGuaranteePreSave from '@/components/guarantee/guarantee-pre-save/useGuaranteePreSave'

/**
 * 保证金预存开通入口
 */
export default {
  name: 'GuaranteePreSaveOpenEntry',

  data() {
    return {
      // 协议是否勾选
      agreementChecked: false,

      visible: false,

      // 服务说明
      serviceDescList: useGuaranteePreSave().getServiceDescList()
    }
  },

  methods: {
    /**
     * 开通保证金预存账户
     */
    openPreSaveAccount() {
      // if (!this.agreementChecked) {
      //   this.$message.info('请先阅读并同意灵活宝用户协议')
      //   return
      // }
      this.$store
        .dispatch('finance/openGuaranteePreSave')
        .then(() => {
          this.$emit('open')
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
.service-open {
  width: 1200px;

  .body-title {
    margin-top: 80px;
    display: flex;
    justify-content: center;

    ::v-deep .el-divider--horizontal {
      width: 50%;
      background-color: $info-second-color;
    }

    .title-icon {
      width: 28px;
    }

    .title-main {
      color: $primary-color;
      font-size: 24px;
      margin: 0 10px;
    }

    .title-second {
      color: $second-text-color;
      font-size: 18px;
    }
  }

  .publicity {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 50px;

    img {
      width: 420px;
      margin-right: 40px;
      margin-bottom: 40px;

      &:nth-of-type(2n) {
        margin-right: 0;
      }

      &:nth-of-type(n + 7) {
        margin-bottom: 0;
      }
    }
  }

  .open-action {
    margin-top: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  ::v-deep .open-button.el-button {
    width: 232px;
    height: 54px;
    border-radius: 27px;
    font-size: 20px;
  }

  .service-desc {
    width: 760px;
    margin: 35px auto 0;

    .desc-title {
      color: $second-text-color;
      font-size: 16px;
    }

    ol {
      padding: 0 0 0 16px;
      margin-top: 24px;
      line-height: 2;

      li {
        color: $third-text-color;
      }
    }
  }
}
</style>
